'use strict'

const { union } = require('folktale/adt/union')
const noop_ = require('lodash/noop')
const merge_ = require('lodash/merge')
const fromPairs_ = require('lodash/fromPairs')
const RavenConstructor = require('raven-js/src/raven')
const { WixCodeViewerApp } = require('@wix/dbsm-common/src/raven/apps')
const {
  configureForViewerWorker
} = require('@wix/dbsm-common/src/raven/configureForViewerWorker')

const ravenHandlerCreator = ({
  global,
  appName,
  ravenOptions,
  ravenClientCreator = () => new RavenConstructor()
}) => () => {
  const raven = ravenClientCreator()
  configureForViewerWorker({
    Raven: raven,
    globalScope: global,
    dsn: WixCodeViewerApp.dsn,
    appName,
    params: ravenOptions
  })

  const createReportOptions = ({ level, sessionData, options = {} }) => {
    return merge_({ level }, { extra: sessionData }, options)
  }

  const getResponseDataFromError = error => {
    try {
      if (error.response) {
        const { headers, status, url } = error.response
        return {
          headers: fromPairs_([...headers.entries()]),
          status,
          url
        }
      }
    } catch (e) {
      return e.stack
    }
  }

  const captureException = ({ error, options, sessionData }) => {
    const extraResponseData = getResponseDataFromError(error)
    const finalOptions = merge_(createReportOptions({ sessionData, options }), {
      extra: {
        responseData: extraResponseData
      }
    })
    raven.captureException(error, finalOptions)
  }

  return {
    init: ({ user }) => {
      raven.setUserContext(user)
    },
    log: logEvent => {
      logEvent.matchWith({
        Breadcrumb: ({ breadcrumb }) => raven.captureBreadcrumb(breadcrumb),
        Info: ({ message, options, sessionData }) => {
          raven.captureMessage(
            message,
            createReportOptions({ level: 'info', sessionData, options })
          )
        },
        Warn: ({ message, options, sessionData }) => {
          raven.captureMessage(
            message,
            createReportOptions({ level: 'warning', sessionData, options })
          )
        },
        Error: ({ error, options, sessionData }) =>
          captureException({ error, options, sessionData }),
        [union.any]: noop_
      })
    }
  }
}

module.exports.ravenHandlerCreator = ravenHandlerCreator
